import React from "react";
import styled from "styled-components";

interface buttonI {
  text: string;
  handleClick: () => void;
}

const MenuButton: React.FC<buttonI> = ({ text, handleClick }) => {
  return <StyledButton onClick={handleClick}>{text}</StyledButton>;
};

const StyledButton = styled.div`
  display: flex;
  margin: 0 5px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 3px;
  padding: 10px;
  transition: ease 0.5s;
  &:hover {
    text-decoration: none;
    background-color: #63BCE5;
    color: #FFFFFF;
  }
  @media (max-width: 900px) {
    margin: 5px;
  }
`;

export default MenuButton;
